// @flow
import {
    OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER,
    OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER,
    OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER,
    OPEN_LOGIN_MODAL_FROM_CHECKER,
    OPEN_PREFERENCES_MODAL_FROM_CHECKER,
    OPEN_SET_PASSWORD_MODAL_FROM_CHECKER,
    OPEN_SIGN_UP_MODAL_FROM_CHECKER,
} from './shouldLogin';
import { COMPLETE_ACCOUNT_SUCCESS } from './completeAccount';
import { CREATE_ACCOUNT_SUCCESS } from './createAccount';
import { createSelector } from 'reselect';
import { FORGOT_PASSWORD_FAIL } from './forgotPassword';
import { getCreditCard } from './creditCard';
import { getUserData } from './user';
import type { GlobalState } from '../rootReducer';
import { LOGIN_SUCCESS } from './login';
import { modalTypes } from '../../enums';
import paymentProviders from '../../enums/paymentProviders';

/* Action Types */
export const COMPLETE_COMPLETE_ACCOUNT_MODAL = 'COMPLETE_COMPLETE_ACCOUNT_MODAL';
export const COMPLETE_CONFIRM_PASSWORD_MODAL = 'COMPLETE_CONFIRM_PASSWORD_MODAL';
export const COMPLETE_LOGIN_MODAL = 'COMPLETE_LOGIN_MODAL';
export const COMPLETE_FOLLOW_SEARCH_MODAL = 'COMPLETE_FOLLOW_SEARCH_MODAL';
export const COMPLETE_SIGN_UP_MODAL = 'COMPLETE_SIGN_UP_MODAL';
export const COMPLETE_SEND_SELLER_MESSAGE_MODAL = 'COMPLETE_SEND_SELLER_MESSAGE_MODAL';
export const DISMISS_MODAL = 'DISMISS_MODAL';
export const OPEN_ABSENTEE_BID_MODAL = 'OPEN_ABSENTEE_BID_MODAL';
export const OPEN_ADD_CREDIT_CARD_MODAL = 'OPEN_ADD_CREDIT_CARD_MODAL';
export const OPEN_ADD_SEARCH_ALERT_MODAL = 'OPEN_ADD_SEARCH_ALERT_MODAL';
export const OPEN_BID_LIMIT_EXCEEDED_MODAL = 'OPEN_BID_LIMIT_EXCEEDED_MODAL';
export const OPEN_BUY_NOW_MODAL = 'OPEN_BUY_NOW_MODAL';
export const OPEN_CATALOG_ANNOUNCEMENT_MODAL = 'OPEN_CATALOG_ANNOUNCEMENT_MODAL';
export const OPEN_CHANGE_PASSWORD_MODAL = 'OPEN_CHANGE_PASSWORD_MODAL';
export const OPEN_CLASSIC_BIDDING_CONSOLE_MODAL = 'OPEN_CLASSIC_BIDDING_CONSOLE_MODAL';
export const OPEN_COMPLETE_ACCOUNT_MODAL = 'OPEN_COMPLETE_ACCOUNT_MODAL';
export const OPEN_CONFIRM_PASSWORD_MODAL = 'OPEN_CONFIRM_PASSWORD_MODAL';
export const OPEN_CONSIGNMENT_CONFIRM_MODAL = 'OPEN_CONSIGNMENT_CONFIRM_MODAL';
export const OPEN_DOWNLOAD_MOBILE_MODAL = 'OPEN_DOWNLOAD_MOBILE_MODAL';
export const OPEN_FEEDBACK_MODAL = 'OPEN_FEEDBACK_MODAL';
export const OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
export const OPEN_HEALTHCHECK_MODAL = 'OPEN_HEALTHCHECK_MODAL';
export const OPEN_INSTALL_FLASH_MODAL = 'OPEN_INSTALL_FLASH_MODAL';
export const OPEN_LIVE_BID_MODAL = 'OPEN_LIVE_BID_MODAL';
export const OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
export const OPEN_PREFERENCES_MODAL = 'OPEN_PREFERENCES_MODAL';
export const OPEN_REGISTER_FOR_CATALOG_MODAL = 'OPEN_REGISTER_FOR_CATALOG_MODAL';
export const OPEN_REPORT_REVIEW_MODAL = 'OPEN_REPORT_REVIEW_MODAL';
export const OPEN_RETRACT_BID_MODAL = 'OPEN_RETRACT_BID_MODAL';
export const OPEN_REVIEWS_MODAL = 'OPEN_REVIEWS_MODAL';
export const OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = 'OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL';
export const OPEN_SEND_SELLER_MESSAGE_MODAL = 'OPEN_SEND_SELLER_MESSAGE_MODAL';
export const OPEN_SET_PASSWORD_MODAL = 'OPEN_SET_PASSWORD_MODAL';
export const OPEN_SHIPPING_AND_PAYMENT_MODAL = 'OPEN_SHIPPING_AND_PAYMENT_MODAL';
export const OPEN_SIGN_UP_MODAL = 'OPEN_SIGN_UP_MODAL';
export const OPEN_WAITING_FOR_APPROVAL_MODAL = 'OPEN_WAITING_FOR_APPROVAL_MODAL';

// reducer
export const DEFAULT_STATE = {
    addCreditCardModalProvider: paymentProviders.STRIPE,
    modal: modalTypes.NONE,
    searchParams: null,
    signupFromFlattenTheCurvePage: false,
    signupModalSeller: 0,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case COMPLETE_ACCOUNT_SUCCESS:
        case COMPLETE_COMPLETE_ACCOUNT_MODAL:
        case COMPLETE_SEND_SELLER_MESSAGE_MODAL:
        case CREATE_ACCOUNT_SUCCESS:
        case DISMISS_MODAL:
        case LOGIN_SUCCESS:
            return {
                ...state,
                modal: modalTypes.NONE,
            };
        case OPEN_ADD_SEARCH_ALERT_MODAL:
            return {
                ...state,
                modal: modalTypes.ADD_SEARCH_ALERT,
            };
        case OPEN_ADD_CREDIT_CARD_MODAL:
            return {
                ...state,
                addCreditCardModalProvider: action.payload.addCreditCardModalProvider || paymentProviders.STRIPE,
                modal: modalTypes.ADD_CREDIT_CARD,
            };
        case OPEN_ABSENTEE_BID_MODAL:
            return {
                ...state,
                modal: modalTypes.ABSENTEE_BID,
            };
        case OPEN_BID_LIMIT_EXCEEDED_MODAL:
            return {
                ...state,
                modal: modalTypes.BID_LIMIT_EXCEEDED,
            };
        case OPEN_BUY_NOW_MODAL:
            return {
                ...state,
                modal: modalTypes.BUY_NOW,
            };
        case OPEN_CATALOG_ANNOUNCEMENT_MODAL:
            return {
                ...state,
                modal: modalTypes.CATALOG_ANNOUNCEMENT,
            };
        case OPEN_CLASSIC_BIDDING_CONSOLE_MODAL:
            return {
                ...state,
                modal: modalTypes.CLASSIC_BIDDING_CONSOLE,
            };
        case OPEN_COMPLETE_ACCOUNT_MODAL:
        case OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.COMPLETE_ACCOUNT,
            };
        case OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.FOLLOW_SEARCH,
                searchParams: action.searchParams,
            };
        case OPEN_SHIPPING_AND_PAYMENT_MODAL:
            return {
                ...state,
                modal: modalTypes.SHIPPING_AND_PAYMENT,
            };
        case OPEN_SIGN_UP_MODAL:
        case OPEN_SIGN_UP_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.SIGN_UP,
                signupFromFlattenTheCurvePage: action?.payload?.fromFlattenTheCurvePage ?? false,
                signupReferralHouse: action?.payload?.sellerId ?? 0,
            };
        case OPEN_DOWNLOAD_MOBILE_MODAL:
            return {
                ...state,
                modal: modalTypes.DOWNLOAD_MOBILE,
            };
        case OPEN_HEALTHCHECK_MODAL:
            return {
                ...state,
                modal: modalTypes.HEALTHCHECK,
            };
        case OPEN_INSTALL_FLASH_MODAL:
            return {
                ...state,
                modal: modalTypes.INSTALL_FLASH,
            };
        case OPEN_WAITING_FOR_APPROVAL_MODAL:
            return {
                ...state,
                modal: modalTypes.WAITING_FOR_APPROVAL,
            };
        case OPEN_CHANGE_PASSWORD_MODAL:
            return {
                ...state,
                modal: modalTypes.CHANGE_PASSWORD,
            };
        case OPEN_CONFIRM_PASSWORD_MODAL:
        case OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.CONFIRM_PASSWORD,
            };
        case OPEN_CONSIGNMENT_CONFIRM_MODAL:
            return {
                ...state,
                modal: modalTypes.CONFIRM_CONSIGNMENT,
            };
        case FORGOT_PASSWORD_FAIL:
        case OPEN_FORGOT_PASSWORD_MODAL:
            return {
                ...state,
                modal: modalTypes.FORGOT_PASSWORD,
            };
        case OPEN_FEEDBACK_MODAL:
            return {
                ...state,
                modal: modalTypes.FEEDBACK,
            };
        case OPEN_LIVE_BID_MODAL:
            return {
                ...state,
                modal: modalTypes.LIVE_BID,
            };
        case OPEN_LOGIN_MODAL:
        case OPEN_LOGIN_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.LOGIN,
            };
        case OPEN_PREFERENCES_MODAL:
        case OPEN_PREFERENCES_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.PREFERENCES,
            };
        case OPEN_REPORT_REVIEW_MODAL:
            return {
                ...state,
                modal: modalTypes.REPORT_REVIEW,
            };
        case OPEN_RETRACT_BID_MODAL:
            return {
                ...state,
                modal: modalTypes.RETRACT_BID,
            };
        case OPEN_REVIEWS_MODAL:
            return {
                ...state,
                modal: modalTypes.REVIEWS,
            };
        case OPEN_REGISTER_FOR_CATALOG_MODAL:
            return {
                ...state,
                modal: modalTypes.REGISTER_FOR_AUCTION,
            };
        case OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
            return {
                ...state,
                modal: modalTypes.SEND_SELLER_CONSIGNMENT_MESSAGE,
            };
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return {
                ...state,
                modal: modalTypes.SEND_SELLER_MESSAGE,
            };
        case OPEN_SET_PASSWORD_MODAL:
        case OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return {
                ...state,
                modal: modalTypes.SET_PASSWORD,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const modalSelector = (state: GlobalState) => state.modal;

export const getOpenModal = createSelector(modalSelector, modal => modal.modal || modalTypes.NONE);

export const getAddCreditCardModalProvider = createSelector(modalSelector, state => state.addCreditCardModalProvider);
export const getSearchParams = createSelector(modalSelector, state => state.searchParams);
export const getSignupReferralHouse = createSelector(modalSelector, state => state.signupReferralHouse);
export const getSignupFromFlattenTheCurvePage = createSelector(
    modalSelector,
    state => state.signupFromFlattenTheCurvePage
);

/* ACTION CREATORS */
export const closeModalAndCheckCreditCard = (addCreditCardModalProvider: number) => async (
    dispatch: Function,
    getState: Function
) => {
    const state = getState();
    const { creditCardValidated } = getUserData(state);
    let shouldOpen = !creditCardValidated;
    if (addCreditCardModalProvider !== paymentProviders.STRIPE) {
        //TODO this logic will have to be updated when we support multiple bidder cards.
        const creditCard = getCreditCard(state, paymentProviders.PAYRIX);
        shouldOpen = creditCardValidated && !Boolean(creditCard?.address?.address1);
    }

    await dispatch(dismissModal());
    if (shouldOpen) {
        dispatch(openAddCreditCardModal(addCreditCardModalProvider));
    }
};

export const completeLoginModal = () => ({
    type: COMPLETE_LOGIN_MODAL,
});

export const completeSendSellerMessageModal = () => ({
    type: COMPLETE_SEND_SELLER_MESSAGE_MODAL,
});

export const completeSignUpModal = () => ({
    type: COMPLETE_SIGN_UP_MODAL,
});

export const completeFollowSearchModal = () => ({
    type: COMPLETE_FOLLOW_SEARCH_MODAL,
});

export const dismissModal = () => ({
    type: DISMISS_MODAL,
});

export const openAbsenteeBidModal = (itemId: number, bidAmount: number) => ({
    payload: { bidAmount, itemId },
    type: OPEN_ABSENTEE_BID_MODAL,
});

export const openAddCreditCardModal = (addCreditCardModalProvider: number) => ({
    payload: { addCreditCardModalProvider },
    type: OPEN_ADD_CREDIT_CARD_MODAL,
});

export const openAddSearchAlertModal = () => ({
    type: OPEN_ADD_SEARCH_ALERT_MODAL,
});

export const openBidLimitExceededModal = (catalogId: number) => ({
    payload: catalogId,
    type: OPEN_BID_LIMIT_EXCEEDED_MODAL,
});

export const openBuyNowModal = ({ itemId, modalType, offerPrice }: any) => ({
    payload: { itemId, modalType, offerPrice },
    type: OPEN_BUY_NOW_MODAL,
});

export const openChangePasswordModal = () => ({
    type: OPEN_CHANGE_PASSWORD_MODAL,
});

export const openCompleteAccountModal = () => ({
    type: OPEN_COMPLETE_ACCOUNT_MODAL,
});

export const openConfirmPasswordModal = (payload: any) => ({
    payload,
    type: OPEN_CONFIRM_PASSWORD_MODAL,
});

export const openConfirmConsignmentModal = () => ({
    type: OPEN_CONSIGNMENT_CONFIRM_MODAL,
});

export const openDownloadMobileModal = () => ({
    type: OPEN_DOWNLOAD_MOBILE_MODAL,
});

export const openFeedbackModal = () => ({
    type: OPEN_FEEDBACK_MODAL,
});

export const openForgotPasswordModal = () => ({
    type: OPEN_FORGOT_PASSWORD_MODAL,
});

export const openHealthcheckModal = () => ({
    type: OPEN_HEALTHCHECK_MODAL,
});

export const openLiveBidModal = (itemId: number, bidAmount: number) => ({
    payload: { bidAmount, itemId },
    type: OPEN_LIVE_BID_MODAL,
});

export const openLoginModal = () => ({
    type: OPEN_LOGIN_MODAL,
});

export const openPreferencesModal = () => ({
    type: OPEN_PREFERENCES_MODAL,
});

type OpenRegisterForAuctionModalParams = {
    catalogId: number,
    fromBiddingConsole?: boolean,
    itemId?: number,
};
export const openRegisterForAuctionModal = ({
    catalogId,
    fromBiddingConsole = false,
    itemId = 0,
}: OpenRegisterForAuctionModalParams) => ({
    payload: { catalogId, fromBiddingConsole, itemId },
    type: OPEN_REGISTER_FOR_CATALOG_MODAL,
});

export const openRetractBidModal = (itemId: number) => ({
    payload: { itemId },
    type: OPEN_RETRACT_BID_MODAL,
});

export const openSendSellerConsignmentMessageModal = (
    messageDetails: any,
    sellerId: number,
    sellerName: string,
    subject: string,
    title: string
) => ({
    payload: { messageDetails, sellerId, sellerName },
    type: OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL,
});

export const openSendSellerMessageModal = (
    messageDetails: any,
    sellerId: number,
    sellerName: string,
    subject: string,
    title?: string = ''
) => ({
    payload: { messageDetails, sellerId, sellerName, subject, title },
    type: OPEN_SEND_SELLER_MESSAGE_MODAL,
});

export const openSetPasswordModal = () => ({
    type: OPEN_SET_PASSWORD_MODAL,
});

export const openShippingAndPaymentModal = () => ({
    type: OPEN_SHIPPING_AND_PAYMENT_MODAL,
});

export const openCatalogAnnouncementModal = (catalogId: number) => ({
    payload: { catalogId },
    type: OPEN_CATALOG_ANNOUNCEMENT_MODAL,
});

export const openSignUpModal = (sellerId: ?number, fromFlattenTheCurvePage?: boolean) => {
    const action: any = {
        type: OPEN_SIGN_UP_MODAL,
    };
    if (sellerId || fromFlattenTheCurvePage) {
        action.payload = {
            fromFlattenTheCurvePage: Boolean(fromFlattenTheCurvePage),
            sellerId,
        };
    }
    return action;
};

export const openWaitingForApprovalModal = (catalogId: number, hideUrgentMessages: boolean = false) => {
    return {
        payload: { catalogId, hideUrgentMessages },
        type: OPEN_WAITING_FOR_APPROVAL_MODAL,
    };
};

export const openReportReviewModal = (reviewId: number) => ({
    payload: reviewId,
    type: OPEN_REPORT_REVIEW_MODAL,
});

export const openReviewsModal = (sellerId: number) => ({
    payload: sellerId,
    type: OPEN_REVIEWS_MODAL,
});
